<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">“If you give me time, I’ll make my fortune.”</p>
<p class="fm1_1"><span>—<i>Jay Gould</i></span></p>
<p class="fm2">“I shall be rich.”</p>
<p class="fm1_1"><span>—<i>Jay Cooke</i></span></p>
<p class="fm2">“I’m bound to be rich! BOUND TO BE RICH!”</p>
<p class="fm1_1"><span>—<i>John D. Rockefeller</i></span></p>
<p class="fm2">“Oh, I’m rich! I’m rich!”</p>
<p class="fm1_1"><span>—<i>Andrew Carnegie</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?17db1b22